<script>
module.exports = {
  template : '#sidenav-template',
  data     : function() {
    return {
      showMobileNav : false
    };
  },
  computed : {
    messages : function() {
      const messages = this.$store.state.messages ? this.$store.state.messages : [];

      const latestMessages = messages.reduce(function(result, message) {
        if (!message.isRead) result.push(message);

        return result;
      }, []).length;

      return latestMessages > 0 ? latestMessages : false;
    }
  }
};
</script>